import { queryOptions } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { AdminDashboard } from '@/api/generated/types'

export const getDashboard = (signal?: AbortSignal) =>
  api.get<AdminDashboard>('/admin/dashboard', { signal }).then((r) => r.data)

export const dashboardQueries = {
  all: ['dashboard'] as const,
  counts: () =>
    queryOptions({
      queryKey: ['dashboard', 'counts'],
      queryFn: ({ signal }) => getDashboard(signal),
    }),
}
